module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Tomb-Raider.3a7ab1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Tomb-Raider.jpg
// module id = 3oxt
// module chunks = 0